import { axiosInstance } from "./client";
import { TranslatableEnum } from "@rumble-it/common-lib/types/models/TranslatableEnum.interface";

export const getInsuranceTypes = async () =>
  axiosInstance
    .get<TranslatableEnum[]>(`/dossiers/insurance-type`)
    .then((response) => response.data);
